breadcrumbsDirective.$inject = ['$installation'];

export function breadcrumbsDirective($installation) {
    return {
        restrict: 'E',
        template: `
            <a ng-repeat-start="(step, name) in installation.steps" 
               ui-sref="{{ step }}" 
               ui-sref-active="active">
                {{ name }}
            </a>
            
            <span ng-repeat-end ng-if="!$last" class="separator">&gt;</span>
        `,
        link: function(scope) {
            scope.installation = $installation;
        },
    };
}
